import Vue from 'vue'
import VueRouter from 'vue-router'
import AppView from '../views/AppView.vue'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import CadastroUsuarioView from '../views/CadastroUsuarioView.vue'
// import AlterarSenhaView from '../views/AlterarSenhaView.vue'


Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/app/*',
  //   component: LoginView,
  //   // redirect: { name: 'Login' },
  // },
  {
    name: 'Login',
    path: '/app/login',
    component: LoginView,
  },
  {
    name: 'AlterarSenha',
    path: '/app/login/alterar_senha',
    // component: AlterarSenhaView,
    component: () => import(/* webpackChunkName: "alterar_senha" */ '../views/AlterarSenhaView.vue'),
    meta: { requerAutenticacao: true },
  },
  {
    name: 'CadastroUsuario',
    path: '/app/cadastro_usuario',
    component: CadastroUsuarioView,
    // component: () => import(/* webpackChunkName: "cadastro_usuario" */ '../views/CadastroUsuarioView.vue')
  },
  {
    path: '/app',
    component: AppView,
    redirect: { name: 'Home' },
    meta: { requerAutenticacao: true }, //# ### Retirar comentário na Produção ***
    children: [
      {
        name: 'Home',
        path: 'home',
        component: HomeView
      },
      {
        name: 'ConsultarContrato',
        path: 'consultar_contrato',
        // props: { login: sessionStorage.getItem('australopitecus') },
        component: () => import(/* webpackChunkName: "consultar_contrato" */ '../views/ConsultarContratoView.vue')
      },
      // {
      //   name: "GerarContrato",
      //   path: "/../gerar_contrato",
      // },
      {
        name: "GerarContrato",
        path: 'gerar_contrato',
        props: true,
        component: () => import(/* webpackChunkName: "gerar_contrato" */ '../views/GerarContratoView.vue')
      },
      {
        name: 'Pricing',
        path: 'pricing',
        component: () => import(/* webpackChunkName: "pricing" */ '../views/PricingView.vue')
      },
      {
        name: 'Credito',
        path: 'credito',
        // props: { login: atob(sessionStorage.getItem('australopitecus')) },
        component: () => import(/* webpackChunkName: "credito" */ '../views/CreditoView.vue')
      },
      {
        name: 'SalesSentReport',
        path: 'sales_sent_report',
        // props: { login: atob(sessionStorage.getItem('australopitecus')) },
        component: () => import(/* webpackChunkName: "credito" */ '../views/SalesSentReportView.vue')
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  // base: 'process.env.BASE_URL',
  // base: '/app',
  base: '/',
  routes
})

// Não permitir acessar paginas que exigem autenticação 
router.beforeEach((to, from, next) => {
  // eslint-disable-next-line
  // debugger;
  if (to.matched.some(record => record.meta.requerAutenticacao))
    if (sessionStorage.getItem("australopitecus") == null)
      next({ name: 'Login' })
    else
      next()
  else
    next()
})

export default router
